export default function roomCoordiEventListener(room){
    return store => {
        room.addEventListeners({
            room_cstudy_changeUserSticker: ({userId, data}) => {
                store.commit('coordi/SET_USER_STICKER_LIST', {stickerList: data.roomUserStickerList, userId});
            }
        })
    }
}